import { FC } from "react";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";
import { SegmentFilterBy } from "@/apis/bacchus/types";

const CREATED_BY_OPTIONS: { value: SegmentFilterBy; label: string }[] = [
  { value: "all", label: "Anyone" },
  { value: "my", label: "Me" },
  { value: "org", label: "Teammates" },
];

interface SegmentsToolbarProps {
  filterBy: SegmentFilterBy;
  onFilterByChange: (filterBy: SegmentFilterBy) => void;
  /** Prefix for the chips' data-testids (e.g. "quotes") */
  testIdPrefix?: string;
}

export const SegmentsToolbar: FC<SegmentsToolbarProps> = ({
  filterBy,
  onFilterByChange,
  testIdPrefix = "segments",
}) => (
  <Box display="flex" alignItems="center" gap={1} pb={2} pl={1}>
    <Typography variant="body2" color="text.secondary" pr={0.5}>
      Created by
    </Typography>
    {CREATED_BY_OPTIONS.map((option) => (
      <Chip
        key={option.value}
        label={option.label}
        color={filterBy === option.value ? "primary" : "default"}
        variant={filterBy === option.value ? "filled" : "outlined"}
        aria-pressed={filterBy === option.value}
        onClick={() => onFilterByChange(option.value)}
        data-testid={`${testIdPrefix}-created-by-${option.value}-chip`}
      />
    ))}
  </Box>
);
